import { Button, Icon, Text } from '@msc-b2c/shared-components';
import { Button as CartButton, CartEmptyBodyLabelsProps } from '@msc-b2c/interfaces/types';
import styles from './emptyCart.module.scss';
import { getDeviceType } from '../../../utils/utils';
import { navigateOrRedirectToRoute } from '../../../navigationmenu/utils/navigationMenuUtils';
import { useNavigate } from 'react-router-dom';
import { triggerClickCtaEvent } from '../../../utils/myAreaAnalytics';
import { getContainerInfo } from '../../../utils/analyticsUtils';

type EmptyCartProps = {
  labels: CartEmptyBodyLabelsProps;
};

export function EmptyCart({ labels }: Readonly<EmptyCartProps>) {
  const {
    emptyIcon,
    emptyCartPrimaryText,
    emptyCartSupportingText,
    emptyCartButtons = [],
  } = labels;

  const navigate = useNavigate();

  const handleButtonClick = (button: CartButton) => {
    const container = document.querySelector(`.${styles['cmp-emptycart']}`);

    triggerClickCtaEvent({
      cta_dest_link: button.link?.url ?? '',
      click_main_name: button.label,
      container_info: getContainerInfo(container),
      element_position: 'your cart is empty',
      element_type: 'button',
      click_location: 'fixed',
    });

    navigateOrRedirectToRoute(button.link || {}, navigate);
  };

  return (
    <div className={styles['cmp-emptycart']}>
      <div className={styles['cmp-emptycart__container']}>
        <Icon
          icon={emptyIcon}
          styleOption={getDeviceType() === 'mobile' ? 'icon-xlarge' : 'icon-xxlarge'}
        />
        <div className={styles['text-container']}>
          <Text
            text={emptyCartPrimaryText}
            styleOption="h25"
          />
          <Text
            text={emptyCartSupportingText}
            styleOption="cmp-text__big supporting-text"
          />
        </div>
      </div>
      <div className={styles['cmp-emptycart__button-container']}>
        {emptyCartButtons.length > 0 &&
          emptyCartButtons.map((button) => (
            <Button
              key={button.label}
              styleOption="cmp-button__primary cmp-button -extended"
              buttonType="button"
              text={button.label}
              onClick={() => handleButtonClick(button)}
            />
          ))}
      </div>
    </div>
  );
}
